import { usersData } from './shared/state';

export default {
  modules: {
    usersData
  }
};
